import { checkProductType } from 'srcAlias/client/state/utils/checkProductType';
import { EQUITY_INVESTMENT_ACCOUNT } from 'srcAlias/client/enums/productDescriptionCode';
import { EQUITY_INVESTMENT_ACCOUNT_CATEGORY } from 'srcAlias/client/enums/productCategory';
export const getUrlParametersList = (url) => {
  const parameterMap = new Map();
  if (url) {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.forEach((value, key) => {
      parameterMap.set(key, value);
    });
  }
  return Array.from(parameterMap, ([name, value]) => ({ name, value }));
};

export const isMobileJourney = (queryParams) =>
  queryParams && queryParams.source === 'mobilex';

export const modifyUrl = (queryParams, product, isHK = false, isUS = false) => {
  const productDetails = product && checkProductType(product);
  const targetFuncValue =
    productDetails &&
    (productDetails.productType === 'UNIT_TRUST' ||
      productDetails.productType === 'STRUCTURED_PRODUCTS')
      ? 'CKA'
      : 'CAR';
  const entryValue = 'IAO';
  if (process.env.REACT_APP_QUESTIONNAIERS_URL) {
    let url = `${process.env.REACT_APP_QUESTIONNAIERS_URL}?targetFunc=${targetFuncValue}&accountType=${productDetails.accountType}&entry=${entryValue}`;

    url = isMobileJourney(queryParams)
      ? `${url}&source=OHX`
      : `${url}&source=OHI`;
    url = isHK ? `${url}&market_HK=Y` : url;
    url = isUS ? `${url}&market_US=Y` : url;

    console.log('redirect url', url);
    return url;
  }
  return null;
};

export const modifyWealthDashboardUrl = (queryParams, isHK, isUS) => {
  if (!isHK && !isUS && process.env.REACT_APP_WD_URL) {
    const wdUrl = process.env.REACT_APP_WD_URL.replace(/&amp;/g, '&');
    return isMobileJourney(queryParams)
      ? wdUrl.replace('channelID=OHI', 'channelID=OHX')
      : wdUrl;
  }
  return modifyUrl(
    queryParams,
    `${EQUITY_INVESTMENT_ACCOUNT}_${EQUITY_INVESTMENT_ACCOUNT_CATEGORY}`,
    isHK,
    isUS
  );
};
